module.exports = __webpack_public_path__ + "img/smolder.ad00aa4f.jpg";